import React from 'react';
import { useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { useGlobalContext } from '../../context';


const AdminRoutes = () => {

    const{ fetchAdminData} = useGlobalContext();

    const role = window.sessionStorage.getItem('role');

    useEffect(()=>{
        fetchAdminData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //clear session storage timeout
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.sessionStorage.clear();
        }, 1800000);

        return () => clearTimeout(timeout);
    }, []);

    return role === 'admin' ? <Outlet /> : <Navigate to = '/Signin' />
};

export default AdminRoutes;
